import { Component, Inject } from "@angular/core";

import { OnInit } from "@angular/core";

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MessageService } from '../../../services/message.service';
import { MiscService } from '../../../services/misc.service';
import { FieldGeneratorService } from '../../../services/field-generator.service';
import { FormDialogComponent } from 'src/components/form-dialog/form-dialog.component';
import { ConfirmationDialogComponent } from 'src/components/confirm-dialog/confirm-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';

@Component({
    selector: "rm-manage-truck",
    templateUrl: "./manage-truck.component.html",
    styleUrls: ["./manage-truck.component.css"]
})
export class ManageTruckDialogComponent implements OnInit {

    title: string = 'Manage Trucks';
    trucks: any[] = [];
    columns: any[] = [
        { name: 'number', displayName: 'Vehicle No.' },
        { name: 'alternateName', displayName: 'Alternate Name' },
        { name: 'actions', displayName: '', type: 'actions' }
    ];
    gcp: any;

    constructor(
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ManageTruckDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private msgService: MessageService,
        private miscService: MiscService,
        private fgService: FieldGeneratorService,
        private globalCfgService: GlobalCfgService,
        private ebService: EventBusService
    ) { }

    ngOnInit() {

        if (!this.gcp) {
            this.gcp = this.globalCfgService.getGcp();
        }

        this.loadTrucks();
    }

    cancel() {
        this.dialogRef.close();
    }

    loadTrucks() {
        this.miscService.getAssets(this.gcp, 'TRUCK').subscribe(
            (result) => {
                var data = result['data'];

                data.forEach(element => {
                    if (element.isActive) {
                        element.actions = [
                            { name: 'edit', tip: 'Edit truck detail' },
                            { name: 'block', tip: 'Mark as in-active' }
                        ];
                    } else {
                        element.actions = [
                            { name: 'edit', tip: 'Edit truck detail' },
                            { name: 'play_circle_outline', tip: 'Activate truck' }
                        ];
                    }
                });
                this.trucks = data;
            }
        );
    }

    addTruck() {
        var fields = this.fgService.getFields(
            this.columns,
            { description: "", alternateName: '' }
        );
        const dialogRef = this.dialog.open(FormDialogComponent, {
            width: "450px",
            data: {
                title: "Add Truck",
                fields: fields
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log("The dialog was closed", result);
            this.miscService
                .addAsset({
                    number: result.number,
                    type: 'TRUCK',
                    gcp: this.globalCfgService.getGcp(),
                    alternateName: result.alternateName
                })
                .subscribe(
                    (response: any[]) => {
                        this.msgService.showSuccess(this.msgService.truckAdded);
                        this.loadTrucks();
                        this.ebService.assetSource.next();
                    },
                    error => {
                        console.log("Service error:");
                    }
                );
        });
    }

    onActionClicked(e) {
        var rec = e.record;

        switch (e.actionName.name) {
            case 'block':
                var cfmDialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    width: '450px',
                    data: {
                        message: 'Are you sure you want to mark this truck as in-active? Once blocked this truck will not be used for tracking.'
                    }
                });

                cfmDialogRef.afterClosed().subscribe(
                    (result) => {
                        if (result == 'yes') {
                            this.miscService.updateAsset({
                                id: rec.id,
                                isActive: false
                            }).subscribe(
                                () => {
                                    this.msgService.showSuccess(this.msgService.truckInactive);
                                    this.loadTrucks();
                                }
                            );
                        }
                    }
                );
                break;

            case 'play_circle_outline':
                var cfmDialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    width: '450px',
                    data: {
                        message: 'Are you sure you want to mark this truck as active? Once activated, this truck can be used for tracking.'
                    }
                });

                cfmDialogRef.afterClosed().subscribe(
                    (result) => {
                        if (result == 'yes') {
                            this.miscService.updateAsset({
                                id: rec.id,
                                isActive: true
                            }).subscribe(
                                () => {
                                    this.msgService.showSuccess(this.msgService.truckActive);
                                    this.loadTrucks();
                                }
                            );
                        }
                    }
                );
                break;
            case 'edit':
                var fields = this.fgService.getFields(
                    this.columns,
                    rec
                );
                const dialogRef = this.dialog.open(FormDialogComponent, {
                    width: "450px",
                    data: {
                        title: "Edit Truck",
                        fields: fields
                    },
                });

                dialogRef.afterClosed().subscribe(result => {
                    console.log("The dialog was closed", result);
                    this.miscService
                        .updateAsset({
                            id: rec.id, 
                            number: result.number,
                            type: 'TRUCK',
                            gcp: this.globalCfgService.getGcp(),
                            alternateName: result.alternateName
                        })
                        .subscribe(
                            (response: any[]) => {
                                this.msgService.showSuccess(this.msgService.truckUpdate);
                                this.loadTrucks();
                            },
                            error => {
                                console.log("Service error:");
                            }
                        );
                });
                break;

            default:
                console.log('Invalid action: ', e.actionName.name);
        }
    }
}
